const al = {
    migration_title: 'Oferta Për Ty',
    migration_label_days: ' Ditë ',
    migration_label_from_offer_end: 'nga përfundimi i ofertës',
    migration_view_details: 'Detaje',
    migration_details_title: 'Detaje përdorimi',
    migration_info: 'Kontroll, fleksibilitet, siguri',
    migration_step1_title: 'Oferta',
    migration_step2_title: 'Kushtet',
    migration_step3_title: 'Verifikimi',
    migration_step4_title: 'Përfundimi',

    migration_close_modal: 'Kthehu',
    migration_try_again: 'Provo përsëri',
    migration_call_me_back: 'Më telefono',
    migration_reserve: 'Rezervo',

    migration_offer_section_title: '',
    migration_offer_type: 'Rekomandim për ty',
    migration_contract_section_title: 'Zgjidh kohëzgjatjen',
    migration_contract_confirm: 'Vazhdo',

    migration_terms_section_title: 'Kushtet dhe politika e privatësisë',
    migration_terms_collapse_title: 'Lexo të plotë',
    migration_terms_collapse_subtitle: 'Kushtet dhe afatet',
    migration_terms_agree: 'Pranoj',
    migration_terms_agree_all: 'Pranoj të gjitha kushtet dhe politikën e privatësisë',
    migration_terms_accept_info: 'Duke klikuar “Pranoj“ ti pranon të gjitha kushtet',
    migration_terms_accept: 'Pranoj',
    migration_terms_decline: 'Refuzoj',

    migration_account_section_title: 'Të dhënat e regjistrimit',
    migration_account_section_info: 'Vendos numrin tënd personal të kartës së identitetit.\nTë dhënat personale ruhen me kujdes nga Vodafone dhe na sigurojnë që je përdorues i numrit',
    migration_id_placeholder: 'Nr. Personal',
    migration_id_helper_title: 'Shiko info ndihmues',
    migration_id_helper_info: 'Numri personal është numri 10 shifror që gjendet në kartë e identitetit si tregohet në foto',
    migration_email_placeholder: 'Adresa e-mail',
    migration_vat_number_placeholder: 'NIPT',
    migration_vat_number_helper_title: 'NIPT',
    migration_vat_number_helper_info: 'Numri NIPT përmban 10 karaktere dhe gjendet në  çertifikatën e regjistrimit të biznesit,shiko foton sqaruese',
    migration_individual_account: 'Individuale',
    migration_business_account: 'Biznes',
    migration_account_verify_details: 'Verifiko detajet',

    migration_pin_section_title: 'Verifikim I FNP',
    migration_pin_section_info: 'FNP(Fjalëkalim me Një Përdorim)',
    migration_pin_sent_to: 'Të dëguam PIN verifikues në numrin %1$s',
    migration_enter_pin: 'Vendos kodin PIN %1$s-shifror',
    migration_resend_pin: 'Ri-vendos kodin',
    migration_confirm_pin: 'Konfirmo',

    migration_verification_section_title: 'Detaje verifikimi',
    migration_verification_section_info: ' Të lutem plotëso të dhënat si më poshtë, për të vërtetuar që je përdoruesi i numrit, plotëso vlerat e paguara se fundmi për numrin tënd dhe 3 numrat e telefonuar më shpesh.',
    migration_last_recharges_placeholder: 'Vendos 3 vlerat e paguara së fundmi.',
    migration_last_recharges_currency: '%1$s lekë',
    migration_frequently_contacted_placeholder: 'Vendos 3 numrat më të përdorur',

    migration_personal_section_title: 'Të dhëna personale',
    migration_personal_section_info: 'Të lutem plotëso të dhënat e tua personale.',
    migration_name_placeholder: 'Emër',
    migration_surname_placeholder: 'Mbiemër',
    migration_address_placeholder: 'Adresa',
    migration_contact_number_placeholder: 'Numër Kontakti',

    migration_id_section_title: 'Shto ID',
    migration_id_section_info: 'Na duhen të dhënat e mjetit tënd të identifikimit për të verifikuar identitetin tend. Për këtë arsye do të na duhet nje fotografi e kartës së identitetit.',
    migration_scan_id_info: 'Ti mund të shtosh të dhënat e kartës duke e skanuar atë nëpërmjet aparatit tend celular.',
    migration_scanned_image_title: '',
    migration_remove_photo: 'Hiqe foton',
    migration_scan_id_title: 'Skano kartën e identitetit',
    migration_scan_id_instructions: 'Vendos kartën brenda kutisë',
    migration_scaning_id: 'Duke Skanuar...',

    migration_camera_permission_title: 'Leje për të përdorur kamerën',
    migration_camera_permission_message: 'Na duhet leje për të përdorur kamerën e aparatit tënd',
    migration_camera_permission_positive: 'Ok',
    migration_camera_permission_negative: 'Anullo',

    migration_scan_id: 'Skano kartën e identitetit',

    migration_verify_details: 'Verifiko të dhënat',

    migration_selected_section_title: 'Zgjedhja ime',
    migration_selected_section_info: '',

    migration_summary_section_title: 'Kosto Totale',
    migration_summary_section_info: 'Pagesa fikse mujore e planit tënd',
    migration_start_date: 'Data e fillimit',
    migration_start_today: 'Sot %1$s',
    migration_contract_duration: 'Kohëzgjatja',

    migration_confirm: 'Konfirmoj',

    migration_something_went_wrong: 'Diçka nuk shkoi siç duhet',
    migration_error_wrong_id: 'Error, kodi është i gabuar',
    migration_data_not_confirmed: 'Të dhënat nuk janë të konfirmuara',
    migration_back_to_dashboard: 'Kthehu',
    migration_back_to_summary: 'Kthehu tek përmbledhja',
    migration_existing_order_processing: 'Oferta jote po verifikohet',
    migration_oops_problem: 'Oops, diçka nuk shkoi siç duhej!',
    migration_success: 'Urime',
    migration_extra_benefits: ' Më shumë përfitime',
    migration_order_processing: 'Duke u proçesuar',

    migration_congratulation_message: 'Prit vetëm pak minuta për SMS konfirmues të aktivizimit të ofertës dhe shijo komunikimin tënd menjëherë.\nMos harro të vizitosh dyqanin tonë për të plotësuar proçesin me Vodafone.',
    migration_existing_order_message: 'Prit vetëm pak minuta për SMS konfirmues të aktivizimit të ofertës dhe shijo komunikimin tënd menjëherë.\nMos harro të vizitosh dyqanin tonë për të plotësuar proçesin me Vodafone.',

    migration_wrong_id_format: 'Kliko info për parë formatin e saktë.',
    migration_wrong_email_format: 'Vendos saktë adresën email në formatin (email@example.com).',
    migration_wrong_vat_number_format: 'Nr. NIPT ka 10 karaktere',
    migration_wrong_name_format: 'Vendos emrin saktë.',
    migration_wrong_surname_format: 'Vendos mbiemrin saktë dhe pa hapësirë.',
    migration_wrong_address_format: 'Vendos adresën saktë.',
    migration_wrong_contact_format: 'Vendos numrin saktë.',
    migration_wrong_last_recharge_format: 'Vendos vlerën e saktë.',
    migration_wrong_frequently_contacted_format: 'Vendos numrin e kontaktit saktë.',
    migration_processing_action: 'Po ngarkohet...',

    migration_id_error_title: 'Opps…',
    migration_id_error_desc: 'Numri personal nuk përputhet me të dhënat e regjistrimit të numrit.\nRezervo ofertën ose rivendos të dhënat edhe një herë.',
    migration_reservation_success_title: 'Rezervuar për ty',
    migration_reservation_success_desc: 'Oferta tashmë është e rezervuar për ty për 48 orë në çdo dyqan Vodafone. Nxito për ta përfituar para se ajo të ndryshoj përsëri.',

    migration_details_link: 'https://api-web-ci-vfal.vodafone.com/file/inAppMigration/ViewDetails/ViewDetails_AL.html',
    migration_save_button: 'Ruaj',
}

export default al
